import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { GlobalDataService } from './global-data.service';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { APPCONSTANTS } from './app-service.constants';

@Injectable(
  {
    providedIn: 'root',

  }
)
export class HttpConfigInterceptor implements HttpInterceptor {
  private deviceInfo: any;
  private deviceId: any;
  private appInfo: any;
  constructor(
    private alertController: AlertController,
    private globalData: GlobalDataService,
    private router: Router
  ) {}
  async showSessionTimeOutAlert() {
    const alert = await this.alertController.create({
      header: 'Alert',
      message: 'Your Session Expired',
      buttons: [
        {
          text: 'OK',
          handler: data => {
            this.router.navigate(['landing']);
          },
        },
      ],
    });
    alert.present();
  }

  private logDeviceInfo = async () => {
    this.deviceInfo = await Device.getInfo();

   
    this.deviceId = (await Device.getId()).identifier;
    if (Capacitor.getPlatform() !== APPCONSTANTS.WEB) {

    this.appInfo =  await App.getInfo();
    }

  };
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.logDeviceInfo();
    let plt: string = "" + this.deviceInfo?.platform;
    let deviceId:string = "" + this.deviceId;
 var headers;

    console.log("Platform:", Capacitor.getPlatform());
    if( Capacitor.getPlatform() === APPCONSTANTS.WEB ){
      headers = {
        'Content-Type': 'application/json',
        'Platform': plt,
        'DeviceId': deviceId,
        // 'AppVersion': this.appInfo?.version != undefined ? this.appInfo?.version : 'Web',
        'DeviceInfo': this.deviceInfo != undefined ? JSON.stringify(this.deviceInfo) : '',
      } 
    }
    else {

      console.log('AppVersion',this.appInfo?.version);
      headers = {
        'Content-Type': 'application/json',
        'Platform': plt,
        'DeviceId': deviceId,
        'AppVersion': this.appInfo?.version != undefined ? this.appInfo?.version : '',
        'DeviceInfo': this.deviceInfo != undefined ? JSON.stringify(this.deviceInfo) : '',
      }  
    }
  
    request = request.clone({
      setHeaders: headers
    });
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status === 403) {
            this.showSessionTimeOutAlert();
          } else {
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        return throwError(error);
      })
    );
  }
}
